import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWarning = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.75 9a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0zM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.549 3.332c-.656-1.247-2.441-1.247-3.097 0L2.108 19.185a1.75 1.75 0 0 0 1.548 2.565h16.688a1.75 1.75 0 0 0 1.548-2.565zm-1.77.699a.25.25 0 0 1 .442 0l8.344 15.853a.25.25 0 0 1-.221.366H3.656a.25.25 0 0 1-.22-.366z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWarning;
